import React, { useState, useRef, useEffect } from "react";

interface OtpInputProps {
  length: number;
  onComplete: (otp: string) => void;
  isError?: boolean;
}

const OtpInput: React.FC<OtpInputProps> = ({ length, onComplete, isError }) => {
  const [otpValues, setOtpValues] = useState<string[]>(Array(length).fill(""));
  const inputRefs = useRef<HTMLInputElement[]>([]);

  const handleChange = (index: number, value: string) => {
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;

    setOtpValues(newOtpValues);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    if (newOtpValues.every((v) => v !== "")) {
      onComplete(newOtpValues.join(""));
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && otpValues[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedData = event.clipboardData.getData("Text");
    if (pastedData.length === length) {
      setOtpValues(pastedData.split(""));
      onComplete(pastedData);
    }
    event.preventDefault(); // Prevent the default paste behavior
  };

  useEffect(() => {
    if (inputRefs.current.length > 0) {
      inputRefs.current[0]?.focus(); // Focus on the first input when component mounts
    }
  }, []);

  return (
    <div className="otp-input-container flex flex-row gap-2 w-[320px] ">
      {otpValues.map((value, index) => (
        <div
          key={index}
          className={`flex otp-input-container border 
          ${
            isError ? "border-red-400 border-2" : "border-blue_gray-50_04"
          } bg-blue_gray-50_03 
          w-[48px] h-[54px]

          rounded-lg justify-center items-center`}
        >
          <input
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value.toUpperCase())} // Uppercase for uniformity
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            ref={(el) => (inputRefs.current[index] = el as HTMLInputElement)}
            className="otp-input rounded-md text-red-700 text-[30px]"
            style={{ width: "48px", textAlign: "center" }}
            type="password"
          />
        </div>
      ))}
    </div>
  );
};

export default OtpInput;
